module.exports = __webpack_public_path__ + "img/1446493936.f213b93a.jpg";